import stockAPI from "@/utility/api.js";
import { state } from "@/store/reportRatioYear/state.js";
import { getters } from "@/store/reportRatioYear/getters.js";

export const reportRatioYear = {
  state,
  getters,
  mutations: {
    fetchReportRatioYear(state, res) {
      state.reportRatioYear = res;
    },
    fetchErrorMessage(state, error) {
      state.errorMessage = error || "";
    }
  },
  actions: {
    async FETCH_REPORT_RATIO_YEAR({ commit, rootState }) {
      try {
        const res = await stockAPI.GET(
          `/api/report/ratio/year/${rootState.stockSymbol}`
        );
        commit("fetchReportRatioYear", res);
        // 共用 rootState 儲存股票代號。
        commit("storageCompanyName", res, { root: true });
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        // 提示錯誤訊息，優化使用者機制。
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    }
  }
};
